export default function mobilePriorityMenu() {
    const mobileMenuPriority = document.querySelector('.menuMobilePriority-scrollbox');

    if(! mobileMenuPriority) {
        return;
    }

    // the observer is set only once. att 'listening' is a flag indicating it has been set
    if(mobileMenuPriority.getAttribute('listening')) {
        return;
    }

    const compStyles = window.getComputedStyle(mobileMenuPriority);
    
    // only set the observer if the menu is visible - ie on small screens
    if( ! (compStyles.getPropertyValue('display') === 'block')) {
        return;
    }

    const lastItem = document.querySelector('.menuMobilePriority > li:last-child');

    // check to see if the menu fits without scrolling horizontally
    let observer = new IntersectionObserver(
        function (entries, observer) { 
            let menuFits = false;

            entries.forEach(function(entry) {
                if(entry.isIntersecting){
                    menuFits = true;
                }
            });

            if(!menuFits) {
                mobileMenuPriority.classList.add('menu-does-not-fit');
            }
            // set a flag indicating that the observer has been added
            mobileMenuPriority.setAttribute('listening', true);
        }, 
        {   
            root: mobileMenuPriority,
            rootMargin: '0px',
            threshold: 1.0
        }
    );

    observer.observe(lastItem);

    lastItem.addEventListener("animationend", function() {
        mobileMenuPriority.classList.remove('menu-does-not-fit');
    }, false);
}